export type Predicate<T> = (value: T) => boolean;
export type TypeGuard<Input, Output extends Input> = (input: Input) => input is Output;

export function isNotPureArray<A, B>(
  predicate: (value: A | B) => value is B,
  array: ReadonlyArray<A | B>,
): array is readonly A[] {
  return array.some(predicate);
}
